import "core-js/modules/es6.array.fill";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getAction } from '@/api/manage';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import moment, { months } from 'moment';
import waterSameChart from '@/components/biChart/waterSameChart';
import yearRangeDate from '@/components/date/yearRangeDate';
import yearRangeWeek from '@/components/date/yearRangeWeek';
import yearRangeMonth from '@/components/date/yearRangeMonth';
import yearRangeQuarter from '@/components/date/yearRangeQuarter';
import colControl from '@/components/colControl/colControl';
import waterLineChart from '@comp/biChart/waterLineChart.vue';
export default {
  name: 'sameAnalysis',
  mixins: [GetSiteIdMixin],
  components: {
    waterLineChart: waterLineChart,
    waterSameChart: waterSameChart,
    yearRangeDate: yearRangeDate,
    yearRangeWeek: yearRangeWeek,
    yearRangeMonth: yearRangeMonth,
    yearRangeQuarter: yearRangeQuarter,
    colControl: colControl
  },
  data: function data() {
    return {
      colOptions: [],
      initNum: 0,
      reportType: '12',
      limitSelectDate: {},
      stime: '',
      etime: '',
      quantum: '',
      dateFormat: 'YYYY-MM-DD',
      chartBoxHeight: '604px',
      tableData: [],
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      siteId1: ''
    };
  },
  created: function created() {
    this.limitSelectDate = {
      min: moment().startOf('day').subtract(1, 'months'),
      max: moment().endOf('day')
    };
    this.stime = this.limitSelectDate.min.format('YYYY-MM-DD');
    this.etime = this.limitSelectDate.max.format('YYYY-MM-DD');
  },
  props: ['showSiteTree', 'siteId', 'selectType'],
  watch: {
    siteId: {
      handler: function handler(value) {
        if (value) {
          this.siteId1 = value;
        } else {
          this.siteId1 = window.sessionStorage.getItem("siteId");
        }
      },
      deep: true,
      immediate: true
    },
    showSiteTree: {
      handler: function handler(value) {
        if (value === false) {
          this.showSite = false;
        }
      },
      deep: true,
      immediate: true
    },
    currentSiteId: function currentSiteId(value) {}
  },
  filters: {
    weekFormat: function weekFormat(val) {
      var week = '';

      switch (val) {
        case 1:
          week = '周一';
          break;

        case 2:
          week = '周二';
          break;

        case 3:
          week = '周三';
          break;

        case 4:
          week = '周四';
          break;

        case 5:
          week = '周五';
          break;

        case 6:
          week = '周六';
          break;

        case 7:
          week = '周日';
          break;
      }

      return week;
    },
    monthFormat: function monthFormat(date) {
      var time = new Date(date);
      var month = time.getMonth() + 1;
      month = month > 9 ? month : '0' + month;
      return time.getFullYear() + '-' + month;
    },
    dayFormat: function dayFormat(time) {
      var date = time.split(' ');
      var dateTime = date[1].split(':');
      return date[0] + ' ' + dateTime[0];
    }
  },
  methods: {
    onChange: function onChange() {
      var data = {
        seriesData: [],
        source: []
      };
      var res = {
        result: JSON.parse(JSON.stringify(this.$refs.charts.dataSource))
      };
      var str = this.$refs.colControl.selectCol.join(',');
      var dateTime = ['日期'];
      res.result.records.forEach(function (v, i) {
        dateTime.push(v.dataTime);
        data.seriesData.push({
          type: 'bar'
        });
      });
      var dataList = new Array(res.result.query.factors.length).fill([]);
      res.result.query.factors.forEach(function (item, index) {
        if (str.indexOf(item.code) > -1) {
          dataList[index] = [item.alias || item.title];
          res.result.records.forEach(function (v, i) {
            dataList[index].push(v.factor[item.code].value);
          });
        }
      });
      data.source = [dateTime];
      dataList.forEach(function (v) {
        data.source.push(v);
      });
      this.$refs.charts.changeChartInit(data, 1, res.result.query.factors);
    },
    openCol: function openCol(index) {
      if (typeof index == 'number') {
        this.$refs.colControl[0].visible = true;
      } else {
        this.$refs.colControl.visible = true;
      }
    },
    moment: moment,
    searchChart: function searchChart() {
      this.initNum++;
    },
    onYearRangeDate: function onYearRangeDate(value) {
      this.stime = value[0] + '';
      this.etime = value[1] + '';
      this.quantum = value[2];
      console.log('年区间-月日', value);
    },
    onYearRangeWeek: function onYearRangeWeek(value) {
      this.stime = value[0] + '';
      this.etime = value[1] + '';
      this.quantum = value[2];
      console.log('年区间-周', value);
    },
    onYearRangeMonth: function onYearRangeMonth(value) {
      this.stime = value[0] + '';
      this.etime = value[1] + '';
      this.quantum = value[2];
      console.log('年区间-月', value);
    },
    onYearRangeQuarter: function onYearRangeQuarter(value) {
      this.stime = value[0] + '';
      this.etime = value[1] + '';
      this.quantum = value[2];
      console.log('年区间-季度', value);
    },
    onMonthRangeChange: function onMonthRangeChange(value) {
      this.stime = moment(value[0]).format('YYYY-MM');
      this.etime = moment(value[1]).format('YYYY-MM');
    },
    dataTypeChange: function dataTypeChange(e) {
      this.reportType = e.target.value;

      if (e.target.value == '3') {
        this.stime = this.limitSelectDate.min.format('YYYY-MM');
        this.etime = this.limitSelectDate.max.format('YYYY-MM');
      } else if (e.target.value == '1' || e.target.value == '2') {
        this.stime = this.limitSelectDate.min.format('YYYY-MM-DD');
        this.etime = this.limitSelectDate.max.format('YYYY-MM-DD');

        if (e.target.value == '1' && this.analysisType == '4') {
          this.quantum = '';
        }
      }
    },
    getWeek: function getWeek(dt) {
      var d1 = new Date(dt);
      var d2 = new Date(dt);
      d2.setMonth(0);
      d2.setDate(1);
      var rq = d1 - d2;
      var days = Math.ceil(rq / (24 * 60 * 60 * 1000));
      var num = Math.ceil(days / 7);
      return num + 1;
    }
  }
};